var render, staticRenderFns
import script from "./LinksListMixin.vue?vue&type=script&lang=js&"
export * from "./LinksListMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinksListMixin.vue"
export default component.exports